<!--DEV NOTE: please include all the configuration to work with themes. Same was made in vue-ui -->
<template>
	<div
		:class="[
			'nav',
			'vue-side-menu',
			menuHiddenClass,
			isMenuExpanded && 'is-expanded'
		]"
		:mode="activeMode"
		:style="brandingVars"
		data-testid="menu-div"
	>
		<ul class="vue-side-menu__root-menu">
			<li
				class="vue-side-menu__expand-btn"
				@click="handleExpandableMenu"
				data-testid="expand-li"
				v-if="showExpandButton"
			>
				<span class="vue-side-menu__expand-icon">
					<i class="icon icon-arrow-right-circle"></i>
				</span>
			</li>
			<li>
				<VueMenuItem
					class="root-item"
					:menuItem="dashboardMenuItem"
					:isMenuExpanded="isMenuExpanded"
					:isTopLevel="true"
					:isMobile="isMobile"
					:companyId="menuCompanyId"
				/>
			</li>
			<li
				class="vue-side-menu__root-item"
				v-for="menuItem in menuItems"
				:key="menuItem.id"
			>
				<hr
					class="vue-side-menu__divider"
					v-if="menuItem.itemText == 'MyVUE'"
				/>
				<VueMenuItem
					class="root-item"
					:menuItem="menuItem"
					:isMenuExpanded="isMenuExpanded"
					:isTopLevel="true"
					:topLevelParentId="menuItem.id"
					:parentMenuIds="[menuItem.id]"
					:isMobile="isMobile"
					:companyId="menuCompanyId"
				/>
				<hr
					class="vue-side-menu__divider"
					v-if="menuItem.itemText == 'Favorites'"
				/>
			</li>
		</ul>
	</div>
</template>

<script>
import VueMenuItem from './components/vue-menu-item.vue';
import getCompanyId from '@/composables/get-companyid';
import propsMixin from './mixins/parent-component-props';
import { mapGetters, mapActions } from 'vuex';
//import breakpointVars from '@/scss/3-mixins/_breakpoints.scss';

export default {
	name: 'VueUiMenu',
	components: {
		VueMenuItem
	},
	props: {
		preExpand: {
			type: Boolean,
			default: false
		},
		showExpandButton: {
			type: Boolean,
			default: true
		},
		alwaysDesktop: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			activeMode: 'light',
			brandingVars: {},
			childMenus: 0,
			dashboardMenuItem: {
				id: -2,
				itemText: 'Dashboard',
				itemValue: '/',
				iconClass: 'icon-home-2',
				order: 1,
				childItems: []
			},
			windowWidth: window.innerWidth,
			breakpoint: 992, //breakpointVars.menubreakpoint
			menuCompanyId: getCompanyId(this.$route)
		};
	},
	mounted() {
		window.addEventListener('resize', this.onWindowResize);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onWindowResize);
	},
	mixins: [propsMixin],
	async created() {
		this.reponsibleForUserInfo = true;
		await this.getMenuResultsAction(getCompanyId(this.$route));

		if (this.preExpand) {
			this.setMenuIsExpanded(true);
		}
	},
	computed: {
		...mapGetters('user', ['isMenuOpen', 'isMenuExpanded', 'menuResults']),
		menuItems() {
			let items;

			if (this.menuResults !== undefined) {
				items = this.menuResults.childItems;
			}

			return items;
		},
		menuHiddenClass() {
			let hiddenClass = '';

			if (this.isMobile && !this.isMenuOpen) {
				hiddenClass = 'is-hidden';
			}

			return hiddenClass;
		},
		isMobile() {
			if (this.alwaysDesktop) {
				return false;
			}
			return this.windowWidth <= this.breakpoint;
		}
	},
	methods: {
		...mapActions('user', [
			'setMenuIsExpanded',
			'getMenuResultsAction',
			'setMenuIsOpen'
		]),
		handleExpandableMenu() {
			this.setMenuIsExpanded(!this.isMenuExpanded);
		},
		onWindowResize() {
			this.windowWidth = window.innerWidth;
		}
	}
};
</script>

<style lang="scss" scoped>
.vue-side-menu {
	display: inline-block;
	position: fixed;
	background: var(--bg-0);
	color: var(--bg-0-fg-4);
	width: 100%;
	height: calc(100vh - 49px);
	top: 48px;
	overflow-y: auto;
	z-index: $z-level3;

	&.is-hidden {
		display: none;
	}

	&::-webkit-scrollbar {
		display: none;
	}

	&__root-menu {
		padding: $padding-md 0;

		@include mq($from: md-l) {
			padding-top: 0;
		}
	}

	&__item {
		position: relative;
	}

	&__divider {
		width: 92%;
		margin-block-start: $gutter-lg;
		margin-block-end: $gutter-lg;
		margin-inline-start: auto;
		margin-inline-end: auto;
		border: 0;
		height: 1px;
		background: var(--bg-0-fg-1);
		transition: 0.08s all ease;

		@include mq($from: md-l) {
			width: 28px;
		}
	}

	&__expand-btn {
		display: none;

		@include mq($from: md-l) {
			display: flex;
			justify-content: center;
		}
	}

	&__expand-icon {
		display: inline-flex;
		font-size: $expand-icon-font-size;
		padding: $padding-sm;
		cursor: pointer;
	}

	&.is-expanded {
		box-shadow: 6px 0px 5px -4px $neutral-2;

		@include mq($from: md-l) {
			width: 200px;

			.vue-side-menu {
				&__expand-btn {
					justify-content: flex-end;
				}

				&__expand-icon {
					transform: scaleX(-1);
					padding: $padding-sm;
				}
			}

			.item__btn-label {
				display: inline;
			}

			.vue-side-menu__divider {
				width: 180px;
				transition-delay: 0;
			}
		}
	}

	@include mq($from: sm-l) {
		width: 280px;
		border-right: 1px solid $neutral-2;
	}

	@include mq($from: md-l) {
		overflow-y: initial;
		width: 48px;
		transition: 0.08s all ease;
	}
}

@media print {
	.vue-side-menu {
		display: none;
		visibility: hidden;
	}
}
</style>
